module.exports = {
    language: {
        name: 'English'
    },
    button: {
        login: "Login",
        add: "Add",
        query: "Search",
        details:"Details",
        send:"Release",
        loaction:"Get Location Information",
        save: "Save",
        update: "Edit",
        reset: "Reset",        
        exportUpgradeResult: "Export",
        confirm: "Confirm",
        cancel: "Cancel",
        delete: "Delete",
        addCcn: "Add Controller Software CCN",
        pushCcnTable: "Download Table",
        upCcnVersion: "Upgrade Version",
        copyCcn: "Copy Ccn",
        createUser: "Add User",
        createRole: "Add Role",
        editRole: "Edit Role",
        OperatingLicense: "Operation Authorization",
        createFirstLevelMenu: "Add Level 1 Menu",
        createSecondLevelMenu: "Add Level 2 Menu",
        editFirstLevelMenu: "Edit Level 1 Menu",
        editSecondLevelMenu: "Edit Level 2 Menu",
        addCountry: "Add Country",
        addRegion: "Add Region",
        addCustomerCenter: "Add Customer Center",
        addProvince:"Add Province",
        addLiaisonOffice: "Add Branch Office",
        updateCountry: "Edit Country",
        updateRegion: "Edit Region",
        updateCustomerCenter: "Edit Customer Center",
        updateProvince:"Edit Province",
        updateLiaisonOffice: "Edit Branch Office",
        addCustomer: "Add Customer",
        updateCustomer: "Edit Customer",
        managementArea: "Area Management",
        addAirCompressionStation: "Add Product Station",
        editAirCompressionStation: "Edit Product Station",
        addProductLine: "Add Product Line",
        addProductCategories: "Add Product Category",
        addSmallClassProduct: "Add Power Range",
        addMachineType: "Add Model",
        upload: "Upload",
        addGateway: "Add Gateway",
        gatewayBinding: "Gateway Binding",
        relieveGateway: "Relieve Gateway",
        QRcode: "QRcode",
        resendPointTable: "Resend Point Table",
        addAgency: "Add Distributor",
        updateAgency: "Edit Agency",
        bulkImport: "Import Batch List",
        bulkImportExpertAdvice:"Import Expert Advice",
        bulkImportServiceType:"Import Batch Service Type",
        bulkImportAgency: "Bulk Import Agency",
        bulkImportCustomer:"Bulk Import Customer",
        startImport: "Start Import",
        chooseFile: "Choose File",
        uploadImg:"Upload Image",
        Statistics:"Statistics",
        exportReport:"EXCEL Output",
        createPushMessage:"Create Business Information",
        exportCustomerList:"Export Customer List",
        exportAgencyList:"Export Distributor List",
        exportAll:"Export All",
        exportEquipmentIndexData:"Export Equipment Ccn Index Data",
        exportRecord:"Export Record",
        export:"Export",
        exportDetail:"Export Detail",
        dprm:"Determine push routine maintenance?",
        dsl:"Determine service loss?",
        addBrand:"Add Brand",
        editBrand:"Edit Brand",
        viewExpertAdvice:"View Expert Advice",
        sendEmail:"Send Email",
        batchAdd:"Batch Add",
        healthReport: "Health Report"
    },
    tips: {
        NA:"No data",
        success:"Success",
        error:"Error",
        importFail:"Import failed",
        requestError: "Request Error",
        deleteSuccess: "Delete Success",
        enterCorrectEmail: "Please enter the correct email address!",
        validate: "Please enter the complete!",
        selectRole: "Please select roles!",
        createSuccess: "Create Success",
        updateSuccess: "Edit Success",
        activeSuccess:"Activation successful",
        freezingSuccess:"Freezing succeeded",
        enterAccount: "Please Enter Account",
        enterUserName: "Please Enter UserName",
        enterEmail: "Please Enter Email",
        enterSort: "Please Enter Sort",
        enterDescribe: "Please Enter Describe",
        enterUrl: "Please Enter Url",
        enterName: "Please Enter Name",
        enterParentMenu: "Please Enter ParentMenu",
        noPerimission: "No Perimission, Please connect admin!",
        saveSuccess: "Save Success",
        saveFailed: "Save Failed",
        oprationSuccess:"Operate Success",
        bindSuccess:"Bind Success",
        relieveSuccess:"Relieve Success",
        importSuccess:"Import Success",
        pushSuccess:"Push Success",
        loginFailed: "Account or password error",
        needed: "It's needed",
        mustNumebr:"Please enter number",
        uploadInfo: "The size of uploaded images should not exceed 5MB",
        uploadInfo2: "Only JPG/PNG files and no more than 500KB can be uploaded",
        uploadInfo3:"Only JPG/PNG/BPM files and no more than 500KB can be uploaded",
        uploadInfo4:"The size of uploaded images should not exceed 10MB",

        isRelieveGateway: "Are you sure about untying?",
        isRelease:"Are you sure about the release?",
        enterPwd: "Please enter password",
        enterAgain: "Please enter again",
        pwdTips:"The password should contain at least three uppercase letters, lowercase letters, numbers and symbols, and the length should not be less than 8 bits",
        twoPawNotSanme: "The password is not the same twice",
        warning: "Warning",
        selectMonitoringParameters:"Please Select Monitoring Parameters!",
        selectDate:"Please Select Date",
        selectTime:"Please Select Time",
        sendSuccess:"Release Success",
        fillServiceNumber:"Please fill in the service number!",
        enterRoleName:"Please Enter Role Name!",
        enterRoleDisplay:"Please Enter Role DisplayName!",
        enterOrderNumber:"Please Enter Order Number!",
        mailSendingFailed:"Mail sending failed!",
        mailSendingSuccessfully:"Mail sending successfully!",
        downloadImg:"Save as Image",
        downloadExcel:"Download Excel",
    },
    desc: {
        UseRate:"use rate",
        Loading:"loading",
        downloadDataDetails:"download alarm monitor",
        withinTheContractWarrantyPeriod:"Within Warranty Coverage",
        outsideTheContractWarrantyPeriod:"Outside Warranty Coverage",
        isConnectedAsset: "IsConnectedAsset",
        isRegisteredAsset: "IsRegisteredAsset",
        locationAddress: "Location Address",
        recent1D: "one day",
        recent3D: "three days",
        recent1W: "one week",
        recent1M: "one month",
        recentThreeM: "three months",
        recent3M: "Last 3 months",
        t3To6M: "3 to 6 months",
        t6To12M: "6 to 12 months",
        t1YAgo: "1 year ago",
        faultSnapshot: "Trip Snapshot",
        timestamp:"Timestamp",
        SE列表: "SE",
        SSE列表: "SSE",
        Dealer列表: "Dealer",
        SE: "SE",
        SSE: "SSE",
        Dealer: "Dealer",
        onWarning: "Warning",
        onTrip: "Trip",
        "codeAlarm":"(Code",
        "rightkuohao": ")",
        "simpleChinese": "Chinese",
        "english": "english",
        "客户": "Customer",
        "设备": "Equipment",
        "客户中心": "Customer Center",
        "客户列表": "Customer List",
        "设备列表": "Equipment List",
        "客户中心列表": "Customer Center List ",
        equipment: "Equipment",
        registrationNumber:"Registration Number",
        insightType:"Insight Type",
        screeningTime:"Screening Time",
        lastReplaceTime:"Last Replace Date",
        beforRunningTime:"Before Running Hour",
        replaceTime:"Replacement Cycle",

        noPicture:"No Image",
        customerHotline:"Customer Hotline",
        customerHotlineEn:"",
        domesticHotline:"Domestic Hotline",
        globalHotline:"Global Hotline",
        exportFailed:"Export Failed",
        lastmonth:"Last Month",
        monthOnMonth:"Month-on-Month",
        monthUpdate:"Monthly Update",
        current:"Current",
        userName: "UserName",
        name: "Name",
        roleName: "Role",
        displayName: "Role Name",
        description:"Description",
        all: "All",
        select: "Please Select",
        enterAdminPwd: "Please enter current account password",
        code: "Code",
        NO: "ID",
        automaticallyCreation: "Automatically generated after creation",
        autogeneration: "Autogeneration",
        password: "Password",
        page: "Level-1 Menu",
        childPage: "Level-2 Menu",
        permissions: "Permissions",
        none: "None",
        yes: "Yes",
        no: "No",
        是:"Yes",
        否:"No",
        isEnable: "Enable",
        parentMenu: "Level 1 Menu",
        icon: "Icon",
        describe: "Description",
        sort: "Sort",
        keyword: "Keyword",
        dsn: "Dsn",
        gsn: "Gsn",
        ccn: "Ccn",
        customerName: "Customer Name",
        projectName:"Project Name",
        region: "Region",
        province: "Province",
        city: "City",
        straightPipe: "Directly Managed",
        dealer: "Distributor Managed",
        serviceDistributor: "Service Distributor",
        middleman:"Middleman",
        other: "Others",
        直管:"Directly Managed",
        直销:"Directly Managed",
        经销商:"Distributor Managed",
        服务经销商:"Service Distributor",
        中间商:"Middleman",
        其他:"Others",
        airCompressionStation: "Product Station Name",
        gatewaySN: "Gateway SN",
        airCompressorSN: "Product SN",
        gatewayBindingStatus: "Gateway Binding Status",
        signalStrength: "Signal Strength",
        BaudRate: "Baud Rate",

        ServiceOrderCode:"Service Order Code",
        serviceItem:"Service Item",
        pmc:"Periodic Maintenance Checklist",
        serviceComparison:"Service Comparison",
        serviceDetails:"Service Details",
        workExtent:"Work Extent",
        routineMaintenance2000:"2000 Hours Maintenance",
        routineMaintenance4000:"4000 Hours Maintenance",
        routineMaintenance8000:"8000 Hours Maintenance",
        routineMaintenance16000:"16000 Hours Maintenance",
        routineMaintenance16000More:"More Than 16000 Hours Maintenance",

        ccnDatabits: "Data Bit",
        ccnStopbit: "Stop Bit",
        ccnCheckbit: "Parity Bit",
        ccnCom: "Serial Port",
        IP: "IP Address",
        port: "Port Number",
        oddNumber: "Odd Number",
        evenNumber: "Even Number",
        customerList: "Customer List",
        authList:"Permission List",
        customer: "Customer",
        customerCenter: "Customer Center",
        null: "",
        project:"Project",
        managerPwd: "Manager password",
        department: "Department",
        dealername: "Distributor Name",
        state: "Status",
        normal: "Normal",
        stop: "Stop",
        正常:"Normal",
        停止:"Stop",
        changePaw: "Change Password",
        LogOut: "Logout",
        AirCompressorFailureRate:"Product Rate",
        TotalRegistratedNumber:"Registered",
        OnlineNumber:"Connected-Active",
        DisconnectedNumber:"Connected-Offline",
        High:"High",
        Low:"Low",
        TripNumber:"Trip",
        AirCompressorUtilizationRate :"Product Utilization Rate",
        WarningNumber :"Warning",
        NumberforService :"Machines Due for Service",
        NumberofServiceOverdue:"Machine Past Due for Service",
        ServiceLossRate :"Service Loss Rate",
        RecentDaysAirCompressorRegistrationTrend :"Registration Rate",
        AirCompressorsDailyRegistrationNumber:"Products Daily Registration Number ",
        UtilizationRateofVariousIndustries :"Utilization Rate",
        DeviceRate:"Utilization Rate of Last Month",
        recent12loadingRate:"Loaded Rate of Last 12 Months",
        sendOutNumber:"Shipped",
        relieveBindCount:"Relieve Bind",
        goBack:"Go Back",
        tai:" ",
        Industryutilizationrate:"Utilization Rate",
        useratio:"Use Ratio",
        gross:"Gross",
        Aircompressorunit:"Product Unit",
        food:"Food",
        publicutilities:"Public Utilities",
        MiningAuxiliaryActivity:"Mining Auxiliary Activity",
        miningindustry:"Other Mining (excluding Oil and Gas)",
        oilandgasexploitation:"Oil and gas exploitation",

        run:"Run",
        Run:"Run",
        stop:"Stop",
        Stop:"Stop",
        load:"Load",
        Load:"Load",
        Unload:"Unload",
        stopAndError:"Stop Trip",
        stopAndErrorAndWarn:"Stop Trip",
        stopAndWarn:"Stop Warning",
        loadAndWarn:"Load Warning",
        loadAndTrip:"Load Trip",
        UnloadAndWarn:"Unload Warning",
        //Xe-145F状态
        运行:"Run",
        停机:"Stop",
        加载:"Load",
        卸载:"Unload",
        警告:"Warning",
        故障:"Trip",
        "停机 故障":"Stop Trip",
        "停机 故障 警告":"Stop Trip",
        "停机 警告":"Stop Warning",
        "加载 警告":"Load Warning",
        "卸载 警告":"Unload Warning",
        "已卸载 警告":"Unload Warning",
        "Stop Trip":"Stop Trip",
        "Stop Trip Warning":"Stop Trip",
        "Stop Warning":"Stop Warning",
        "Load Warning":"Load Warning",
        "Unload Warning":"Unload Warning",
        "Unloaded Warning":"Unloaded Warning",
        等待: "Waiting",
        惯性运转: "Coasting",
        启动: "Starting",
        未准备好: "Not Ready",
        准备好: "Ready",
        喘振卸载: "Surge Unload",
        自动双卸载: "Autodual Unload",
        卸载中: "Unloading",
        最小负荷: "Min load",
        最大负荷: "Max load",
        加载中: "Loading",
        满负荷: "Full Load",
        模拟输入故障: "Analog Input Error",
        空压机综合跳闸: "Product Trip",
        空压机综合报警: "Product Warning",
        //MU状态
        尚未做好启动准备: "Not Ready To Start",
        准备启动: "Ready To Start",
        正在启动: "Prestart",
        加速: "Starting",
        运行: "Running",
        正在停止: "Stopping",
        惯性惰转: "Coast down",
        "运行/已报警": "Running Alarmed",
        已加载: "Loaded",//两个都有
        已卸载: "Unloaded",//两个都有
        正在加载: "Loading",
        正在卸载: "Unloading",
        启动中:"Starting",
        运行中:"Running",
        休眠运行中:"Auto-Restart",
        停机准备中:"Ready For Stop",
        故障停机闭锁:"Failure Stop Block",
        紧急停机闭锁:"Emergency Stop Lock",
        上电自检中:"Power-On Self Test",
        换水中:"Change Water",
        空载运行:"No-Load Running",
        自动加载:"Automatic Loading",
        自动卸载:"Automatic Unloading",
        手动加载:"Manual Loading",
        手动卸载:"Manual Unloading",
        停机闭锁:"Stop Block",
        紧急停止请复位:"Emergency Stop Please Reset",
        故障请检查:"Fault Please Check",

        offline:"Offline",

        stoping:"Stop",

        pmPureLabor:"PM Pure Labor",
        oneTimePM:"One-Time PM",
        extendWarranty:"Extended Warranty",
        factoryWarranty:"Factory Warranty",
        hours:"Hours",
        simpleHours:" H",
        PACKAGECARE:"PackageCARE",
        "PLANNEDCARE（有延保）":"PlannedCARE (W EW)",
        "PLANNEDCARE（无延保）":"PlannedCARE (W/o EW)",
        PARTSCARE:"PartsCARE",
        "CARE（定期保养-纯服务）":"CARE (PM – Labor only)",
        "CARE（延长保修）":"CARE (extended warranty)",
        "CARE（一次保养）":"CARE (One-time Maintenance & Service)",
        "CARE（清洗服务）":"CARE (Cooler cleaning service)",
        "Ultimate CARE Pro(旗舰版)":"Ultimate CARE Pro",
        "Ultimate CARE Select(精选版)":"Ultimate CARE Select",
        "Ultimate CARE Lite(精简版)":"Ultimate CARE Lite",
        "Ultimate CARE Labor(纯人工)":"Ultimate CARE Labor",
        "AOF/EMC":"AOF/EMC",
        "AIRCARE（定期保养）":"AIRCARE (PM)",
        "AIRCARE（定制保障）":"AIRCARE (Customized Maintenance)",
        "AIRCARE（全面保障）":"AIRCARE (360 Maintenance)",
        "SELECTCARE（选项1）":"SELECTCARE (Option 1)",
        "SELECTCARE（选项2）":"SELECTCARE (Option 2)",
        "SELECTCARE（选项3）":"SELECTCARE (Option 3)",

        connected:"Connected",
        waitService:"Wait Service",
        unService:"Out-of-date Service",
        online:"Online",
        energyConsumption:"Energy Consumption",
        flux:"Flux",
        customerHotline:"Customer Hotline",
        max:"Max",
        min:"Min",
        average:"Average",
        refresh:"Refresh",
        noData:"No Data",
        "No data":"No Data",
        beingDevelop:'Developing',
        comeSoon:'Coming Soon',
        developInfo:"Sorry, The Page You Visited Is Under Development",
        healthDegree:"Health Rate",
        allInCost:"All-in Cost",
        AverageMonthly:"Average Monthly",
        yuan:" ",
        customerArea:"Region",
        NotAbletoConnect:"Disconnected",        
        SendOutCount:"Shipped",
        shipped_penddingConnect:"Shipped-Disconnected",
        wait_bind:"Pending Registered",
        already_bind:"Registered",
        Connected_Offline:"Connected-Offline",
        Connected_Active:"Connected-Active",
        UtilizationRate:"Utilization Rate",
        times: "Times",
        MachinesDueService :"Machines Due for Service ",
        MachinePastDueService :"Machine Past Due for Service",
        ActiveCriticalAlarmsTrips:"Unit Trip",
        EstimatedPowerConsumption:"Energy Prediction",
        Insight3:"Sales lead _ High Separator Element DP",
        Insight4:"Sales lead _ High Oil Filter DP",
        Insight5:"Sales lead _ High Air Filter DP",
        EstimatedFlow:"Traffic Prediction",
        RetroFit:"RetroFit",
        FactoryFit:"Factory Fit",
        RetroFitBind:"RetroFit-Registered",
        FactoryFitBind:"Factory Fit-Registered",
        FactoryFitWaitBind:"Factory Fit-Pending Registered",
        RetroFitWaitBind:"RetroFit Fit-Pending Registered",
        RetroFitOffLine:"RetroFit-Offline",
        FactoryFitOffline:"Factory Fit-Offline",
        RetroFitOnLine:"RetroFit-Active",
        FactoryFitOnline:"Factory Fit-Active",
        
        IndependentGSNCount:"Stand Alone Edge Equipment",
        IndependentGSNBindCount:"Stand Alone Edge Equipment Registered",
        IndependentGSNWaitBindCount:"Stand Alone Edge Equipment Pending Registered",
        IndependentGSNOnLineCount:"Stand Alone Edge Equipment-Active",
        IndependentGSNOffLineCount:"Stand Alone Edge Equipment-Offline",
        IntegratedGSNCount:"Integrated Edge Equipment",
        IntegratedGSNBindCount:"Integrated Edge Equipment Registered",
        IntegratedGSNWaitBindCount:"Integrated Edge Equipment Pending Registered",
        IntegratedGSNOnLineCount:"Integrated Edge Equipment-Active",
        IntegratedGSNOffLineCount:"Integrated Edge Equipment-Offline",

        IoTGSMCosts:"Last Month SIM Fee",
        ForecastService:"Service Prediction",
        Warranty:"Warranty Period",
        OfflineNormal:"Offline-Normal",
        OfflineFault:"Offline-Fault",
        monthly:'Monthly',
        quarterly:'Quarterly',
        annual:'Annual',
        operateUser:'Operate User',
        loginUser:'Login User',        
        pacCcnImportDealed:"Import MU Ccn File",
        pacCcnImportController:"Import Controller Csv File",
        pacCcnImportTemplate:"Controller Import Template",
        pacCcnDealImportTemplate:"MU Ccn Template",
        exportTemplate:"Import Template",
        exportExpertAdviceTemplate:"Expert Advice Import Template",
        exportTemplateServiceType:"Service Type Import Template",
        exportManEquipmentRelTemplate:"Man Equipment Import Template",
        lost:"Lost",
        notlost:"Not Lost",
        pushed:"Pushed",
        notPush:"Not Push",
        maintained:"Maintained",
        notMaintained:"Unmaintained",
        expireMaintain:"Past Due for Service",
        utilizationtrend:"Utilization Rate of Last 12 Months",
        loadedChangeTrend:"Load/Unload Events of the Last 1 Month",
        BusinessMessage:'Business information',
        factory:'Factory',
        headquarters:'Headquarters',
        isContainWJ:"Include WuJiang Factory",
        saveAsImage:"Save As Image",
        brandSwitch:"Brand Switch",
        linkOMPlatform:"Digital O&M Platform",
        languageSwitch:"Language Switch",
        curMonthReal:"Current Month Realtime",
        weekLy:"Weekly",
        IoTInsight:"IoT Insight",
        unboundCount:"Unbound Count",
        PasswordModifiedSuccessfully:"Password modified successfully!",

        alarmAbstract:"Alarm Abstract",
        customerAssent:"Customer Assets",
        alarmTime:"Alarm Time",
        serviceRecord:"Service Record",
        estimatedServiceDate:"Estimated Service Date",
        tendency:"Tendency",
        loadingRate:"Loading Rate",
        DailyRunningTime:"Daily Running Time",
        alarmInfo:"Alarm Infomation",
        possibleCauseOfFailure:"Possible Cause Of Failure",
        solution:"Solution",
        viewDetail:"View Detail",
        compressorNumber:"Product Number",
        downloadFileNotFound:"Download file not found",
        detailedDataNotFound:"Detailed data not found",
        ssoAccount:"SSO Account",
        systemAccount:"System Account",
        emcCustomer:"EMC Customer Account",
        "accountVerificationSuccessful": "Account verification successful, redirecting…",
        "accountVerificationFail":"Account verification failed, return to login page in ",
        "returnLoginPageSecond": " seconds",
        "useIRAccountLogin": "Log in with IR account",
        "equipmentRegistrationList": "Equipment Registration List",
        "确定获取定位信息吗": "Are you sure to get the location information",
        "noAccess": "No Access!",
        "sorry": "Sorry!",
        "cantuse": "You do not have permission to use this feature, please contact system administrator to upgrade your permissions",
        "monitorMode": "Monitor Mode",
        "createUserDeviceRel":"Create Man Equipment Comparison",
        "UserDeviceRelList":"Man Equipment Comparison List",
        "syncSfaAuthOpen": "Sfa permission enabled",
        "syncSfaAuthClose": "Sfa permission turned off",
        "isSyncSfaAuth": "Whether to enable the SFA permission",
        "sfaEquipmentList": "Man Equipment Comparison List",
        "contractStatus": "Contract Status",
        "contractStartDate": "Contract Start Date",
        "contractEndDate": "Contract End Date",
        "responsibleServiceSalesName": "Responsible Sales",
        "responsibleEngineerName": "Responsible Engineer",
        "responsibleServiceSalesMobile": "Responsible Sales Mobile",
        "responsibleEngineerMobile": "Responsible Engineer Mobile",
        "installDate": "Install Date",
        "lastOverhaulInstallDate": "Last Overhaul Install Date",
        "lastOnlineTime": "Last Online Time",
        week: "week",
        month: "month",
        all:"all",
        Count:"Count",
        Range:"Range",
        creationTime:"Creation Time",
        elecSavingTrendByMonth:"Electricity Saving Trend By Month",
        cycle: "日期",
        CustomerBigRegion:"customer big region",
        uploadRunRecordCount: "Run Record Count",
        uploadRunLoadedCount: 'Run Loaded Count',
        uploadRunUnloadCount: "Run Unload Count",
        uploadUnLoadChangeCount: "UnLoad Change Count"
    },
    title: {
        SubLoadedTime: "sub loaded time",
        SubRunningTime: "sub running time",
        ModelCategoryName: "Model Category",
        name:"Name",
        expertAdvice:"Expert Advice",
        forgetPwd:"Forgot password?",
        ssologin:"SSO Login",
        healthReportTime: "Report Time",
        customerName: "Customer Name",
        cycle: "report date",
        dsns: "dsn",
        gsns: "gsn",
        calcRunningHour: "Running Hour",
        calcLoadedHour : "Loaded Hour",
        currentTermRunningHour: "Current Running Hour",
        currentTermLoadedHour: "Current Loaded Hour",
        rate: "Use Rate",
        loadRate: "Load Rate",
        title: "Product IoT Management Platform",
        staionMonitor:"Station Monitoring Platform",
        //ccnFull: "Controller Software CCN",
        confirmDelete: "Confirm to delete?",
        controllCcn: "Controller Software CCN",
        controllerModel:"Controller Model",
        ccnVersion: "CCN Version",
        ccnCreateTime: "Version CreateTime",
        ccnModifyTime: "Last ModifyTime",
        ccnDirectory: "Parameter General Catalogue",
        creator: "Creator",
        addCcnTitle: "Add CCN",
        editCcnTitle: "Edit CCN",
        upGradeCcnTitle: "Upgrade CCN Version",
        serialNumber: "No.",
        operate: "Operation",
        ccnTable: "CCN Table",
        ccnErrorInfo: "Error Message",
        ccnExpertAdviceInfo: "Expert Advice",
        monitorIndex: "Monitor Index",
        monitorDesc: "Index Description",
        monitorDataType: "Data Type",
        monitorUnit: "Unit",
        monitorType: "Return Type",
        pacCcnSetting:"Ccn Setting",
        pacControllerType: "Controller Model",
        monitorAddress: "Address",
        account: "Account",
        emailAddress: "Email",
        mobilePhone: "Mobile",
        resetPassword: "Reset Password",
        relieveLock: "Relieve Lock",
        relieveLockSuccess: "Relieve Lock Success",
        tips: "Tips",
        editUser: "Edit User",
        selectRole: "Select Role",
        newPassword: "New Password",
        chooseIcon: "Choose Icon",
        isLocked: "IS Locked",
        isActive:'Is Activated',
        country: "Country",
        region: "Region",
        customerCenter: "Customer Center",
        customerTypePac:"Customer Type",
        liaison: "Branch Office",
        chengcity:"city",
        customerCode: "Customer Code",
        managementUnit: "Management Owner",
        managementCode: "Management Owner Code",
        companyType: "Customer Character",
        province: "Province",
        provinceFen:"Province",
        city: "City",
        address: "Address",
        industry: "Industry",
        longitude:"Longitude",
        latitude:"Latitude",
        airCompressionStationAddress: "Product Station Address",
        managementAirCompressionStation: "Air pressure station Management",
        productLine: "Product Line",
        productCategories: "Product Category",
        smallClassProduct: "Power Range",
        machineType: "Model",
        productFamily:"Product Family",
        productFamilyName:"Product Family Name",
        power:"Power",
        dischargePressure:"Discharge Pressure",
        coolingMode:"Cooling Mode",
        imageName: "Image Name",
        colon:":",
        modelImage:"Model Image",
        addProductLine: "Add ProductLine",
        addMachineType: "Add Model",
        updateProductLine: "Edit Product Line",
        updateProductCategories: "Edit Product Category",
        updateSmallClassProduct: "Edit Power Range",
        updateMachineType: "Edit Model",
        isBinding: "Binding Status",
        serviceStatus:"Service Status",
        registerTime:"Binding Time",
        lastBeatTime:"Last Online Time",
        isRegister: "Registration Status",
        UtilizationRate:"Utilization Rate of Last Day",
        GetConnecTime: "String Fetch Time",
        AwsThingCreateTime:"Register AWS Time",
        releaseTime: "Table Release Time",
        uploadCsrTime: "Upload CSR Time",
        GatewayVersion: "Gateway Software Version",
        GatewaySN: "Gateway SN",
        GatewayFirmwareId: "Gateway Firmware ID",
        GatewayFirmwareVersion:"Gateway Firmware Version",
        SIMNumber:"SIM Card Number",
        SIMCount:"pcs",
        SIMLatitude:"SIM Card Latitude",
        GatewayLocation: "Gateway Location",
        GatewayNetworkType: "Gateway Network Type",
        airCompressorRegister: "Product Registration",
        updateAirCompressor: "Edit Product",
        airCompressorType: "Product Type",
        airCompressorService: "Product Service Type",
        controlsCCN: "Controller Software CCN",
        controlsSN: "Controller Hardware SN",

        RelieveCcn:"Relieve Ccn",
        RelieveCcnVersion:"Relieve Ccn Version",
        RelieveGsn:"Relieve Gateway SN",
        FinalRelieveTime:"Final Relieve Time",

        accountType: "Account Type",
        emcName:"EMC Customer Name",
        accountName: "Customer Name",
        tenantAccount: "Customer Account",
        dealercode: "Distributor Code",
        agencystate: "Status",
        errorCode: "Error Code",
        errorDescription: "Error Description",
        errorType: "Error Type",
        AddPointTableData: "Add Parameter General",
        EditPointTableData:"Edit Parameter General",
        addArea: "Add Area",
        Datefrom:"Date from",
        to:"To",
        beginDate:"Start Date",
        endDate:"End Date",
        beginMonth:"Begin Month",
        endMonth:"End Month",
        warning:"Warning",
        trip:"Trip",
        alarmType:"Alarm Type",
        alarmStatus:"Alarm Status",
        dateType:"Date Range",
        alarmTime:"Alarm Time",
        alarmContent:"Alarm Content",
        alarmSta:"Alarm Status",
        alarmCode:"Alarm Code",
        AlarmDetailInformation:"Alarm Detail Information",
        relieveTime:"Relieve Time",
        expertAdvice:"Expert Advice",
        error:"No Relieve",
        relieve:"Relieved",
        area:"Region",
        readStatus:"Read Status",
        read:"Read",
        unread:"Unread",
        AddAlarmReceiver:"Add Alarm Receiver",
        AlarmReceiver:"Alarm Receiver",
        authType:"Authority Type",
        creationTime: "Creation Time",
        AirCompressorBindNumber:"Binded Product Units",
        AirCompressorAlarmNumber:"Product Alarm Number",
        AirCompressorStatus:"Product Status",
        AirCompressorTotalNumber:"Product Total Number",
        AirCompressorBindTotalNumber:"Product Bind Number",

        asOf:"As of",

        gatewaystatus:"Gateway Status",
        RunningTime:"Running Time",
        DischargePressure:"Package Discharge Pressure",
        RatedPressure:"Rated Pressure",
        CurrentStatus:"Current Status",
        LoadedTime:"Loaded Time",
        UnloadedTime:"Unloaded Time",
        DischargeTemperature:"Airend Discharge Temperature",
        DriverMotorCurrent:"Driver Motor Current",
        MotorCurrent:"Motor Current",
        TargetPressure:"Target Pressure",
        VsdMotorSpeed:"Vsd Motor Speed",
        SystemPressure:"System Pressure",
        Stage1Pressure:"Stage 1 Pressure",
        Stage1Virbation:"Stage 1 Virbation",
        Stage1Temperature:"Stage 1 Temperature",
        dischargePressurePac:"Discharge Pressure",
        Stage2InletTemp:"Stage 2 Inlet Temp",

        MonitoringDate:"Monitoring Date",
        MonitoringParameters:"Monitoring Parameters",
        selectFive:"Please select, up to five indicators can be selected",
        ViewMonitoring:"View Monitoring",
        realtimemonitoring:"Real Time Monitoring",
        historymonitoring:"History Monitoring",
        tableDetail:"Ccn Table Detail",
        monitortableDetail:"Monitor Table Detail",
        deviceInsight:"Motor Vibration Monitor",
        minutes:"Minutes",
        Index:"Index",
        number:"Number",
        time:"Time",
        chooseDate:"Choose Date",
        CooperationStatus:"Authorization Status",
        enterOriginalPwd:"Enter the original password",
        setNewPwd:"Set A New Password",
        setNewPwdAgain:"Enter The New Password Again",

        viewMonitor:"View Monitor",
        warnMonitor:"Warning Monitor",

        logType:"Log Type",
        logTitle:"Log Title",
        logContent:"Log Content",
        errorMsg:"Error Message",
        remark:"Remark",
        customerType:"Customer Type",
        monitorDataDetail:"Monitoring Details",
        ccnDataDetail:"Ccn Detail",
        creatTime:"Creat Time",
        updateTime:"UpdateTime",
        loginTime:'LoginTime',
        batchImportCustomer:"Bulk Import To Customers",
        batchImportGetway:"Bulk Import Gateway",
        batchImportServiceHistory:"Import Maintenance History",
        batchImportModel:"Bulk Import Model",
        Imgtitle:"Title",
        Image:"Image",
        mainImage:"Main Image",
        msgContent:"Message Content",
        editMsg:"Modify The Commercial Push Message",
        checkMsg:"View Commercial Push Messages",
        Alarm_View: "Alarm",
        maintainTab: "Maintenance",
        Bound:"Binded",
        Unbound:"Not binded",
        Registered:'Registered',
        Unregistered:'Unregistered',
        proportion:"Proportion",
        unutilized:"Unutilized",
        SIMCardCost:"Cellular data cost",
        AWSCharges:"AWS Cloud data cost",
        SIMAWS:"SIM Card Fee And AWS Fee Statistics For The Last 3 Months",
        PerUnitMonth:'TOC per unit per month',
        LastMonth:'Last month total',

        fault:"Units had Failure",
        totalNumber:"Total Units",
        faultRate:"Health Rate",
        modelRatio:"Model Ratio",
        modelFaultRate:"Failure Rate by Model",
        industryRatio:"Industry Ratio",
        industryFaultRate:"Failure Rate by Industry",
        regionRatio:"Region Ratio",
        regionFaultRate:"Failure Rate by Region",
        customCenterRatio:"Customer Center Ratio",
        customCenterFaultRate:"Failure Rate by Customer Center",
        ModelUtilizationRate:"Utilization Rate by Model",
        IndustryUtilizationRate:"Utilization Rate by Industry",
        IndustryUtilizationRateTop10:"Utilization Rate by Industry Top10",
        overallUtilizationTrendChart:"Overall Utilization Trend",
        IndustryUtilizationRateTop102:"Utilization Rate by Industry Top10",
        RegionUtilizationRate:"Utilization Rate by Region",
        CustomCenterUtilizationRate:"Utilization Rate by Custom Center Top10",

        //预测维护页面
        runningTime:"Running Time",
        pushCycleMaintain:"Routine Maintenance",
        alreadyMaintained:"Has been maintained",
        maintainLose:"Maintenance Lose",
        maintainType:"Hours Routine Maintenance",
        maintainTypeDesc:"Service Type",
        serviceHistory:"Maintenance History",
        editDate:"Edit Date",
        sendDate:"Release Date",
        pushUser:"Released by",
        serviceConfirmed:"Service Confirmed",

        ccnExportTitle:"CCN Export",
        gtherExportTitle:"Export",
        InformationPush:"Information Push",

        brand:"Brand",
        brandName:"Brand Name",
        brandCode:"Brand Code",
        brandDisplay:"Brand",
        presetDesc:"Controller Model",
        offset:"Offset",
        scale:"Scale",
        default:"Default",
        isShowMonitor:"Show monitor or not",
        showMonitorOrder:"Show monitor order",
        "unbindDate":"Unbind Date",
        healthReport: "Health report",
        reportType: "report type",
        week: "week report",
        month: "month report",
        healthStatus: "health status",
        creationTime: "report time",
        dsn :"dsn",
        gsn:"gsn",
        number: "Number"
    },
    gatewayState:{        
        "正常":"Normal",
        "在线":"Online",
        "警告":"Warning",
        "未连接":"Connected-Offline",
        "脱机":"Offline",
        "离线":"Offline"
    },
    // element组件翻译
    el: {
        colorpicker: {
            confirm: 'OK',
            clear: 'Clear'
        },
        datepicker: {
            now: 'Now',
            today: 'Today',
            cancel: 'Cancel',
            clear: 'Clear',
            confirm: 'OK',
            selectDate: 'Select date',
            selectTime: 'Select time',
            startDate: 'Start Date',
            startTime: 'Start Time',
            endDate: 'End Date',
            endTime: 'End Time',
            prevYear: 'Previous Year',
            nextYear: 'Next Year',
            prevMonth: 'Previous Month',
            nextMonth: 'Next Month',
            year: '',
            month1: 'January',
            month2: 'February',
            month3: 'March',
            month4: 'April',
            month5: 'May',
            month6: 'June',
            month7: 'July',
            month8: 'August',
            month9: 'September',
            month10: 'October',
            month11: 'November',
            month12: 'December',
            week: 'week',
            weeks: {
                sun: 'Sun',
                mon: 'Mon',
                tue: 'Tue',
                wed: 'Wed',
                thu: 'Thu',
                fri: 'Fri',
                sat: 'Sat'
            },
            months: {
                jan: 'Jan',
                feb: 'Feb',
                mar: 'Mar',
                apr: 'Apr',
                may: 'May',
                jun: 'Jun',
                jul: 'Jul',
                aug: 'Aug',
                sep: 'Sep',
                oct: 'Oct',
                nov: 'Nov',
                dec: 'Dec'
            }
        },
        select: {
            loading: 'Loading',
            noMatch: 'No matching data',
            noData: 'No data',
            placeholder: 'Select'
        },
        cascader: {
            noMatch: 'No matching data',
            loading: 'Loading',
            placeholder: 'Select',
            noData: 'No data'
        },
        pagination: {
            goto: 'Go to',
            pagesize: '/page',
            total: 'Total {total}',
            pageClassifier: ''
        },
        messagebox: {
            title: 'Message',
            confirm: 'OK',
            cancel: 'Cancel',
            error: 'Illegal input'
        },
        upload: {
            deleteTip: 'press delete to remove',
            delete: 'Delete',
            preview: 'Preview',
            continue: 'Continue'
        },
        table: {
            emptyText: 'No Data',
            confirmFilter: 'Confirm',
            resetFilter: 'Reset',
            clearFilter: 'All',
            sumText: 'Sum'
        },
        tree: {
            emptyText: 'No Data'
        },
        transfer: {
            noMatch: 'No matching data',
            noData: 'No data',
            titles: ['List 1', 'List 2'], // to be translated
            filterPlaceholder: 'Enter keyword', // to be translated
            noCheckedFormat: '{total} items', // to be translated
            hasCheckedFormat: '{checked}/{total} checked' // to be translated
        },
        image: {
            error: 'FAILED'
        },
        pageHeader: {
            title: 'Back' // to be translated
        }
    },
    menu: {
        Home_View: "Home",
        MultiBrand_View: "Integrated IoT Dashboard",
        EmcStationMonitorScreen_View: "Station Monitoring",
        StationMonitor: "Station Monitoring",
        SystemManagement_View: "System Management",
        CustomerManagement_View: "Customer Management",
        DeviceManagement_View: "Equipment Management",
        DeviceMonitorManagement_View: "Equipment Remote Monitoring",
        AlarmManagement_View: "Alarm Management",
        User_View: "User Management",
        Role_View: "Role Management",
        Menu_View: "Menu Management",
        TEST_HEALTH_REPORT_View: "24/7 Health Report",
        Region_View: "Rotary Region Management",
        PACRegion_View:"PAC Customer Region Management",
        BVRegion_View:"BV Customer Region Management",
        Customer_View: "Customer Information Management",
        DeviceModel_View: "Equipment Model Management",
        Ccn_View: "Rotary CCN Management",
        PacCcn_View: "PAC CCN Management",
        BvCcn_View: "BV CCN Management",
        EnduranceCcn_View: "Endurance Test CCN Management",
        Gateway_View: "Gateway Management",
        Device_View: "Equipment Registration",
        Station_View: "Product Station Management",
        Logger_View: "Operation Log",
        CustomerAccount_View: "Customer Account Management",
        DeviceMonitor_View: "Product Remote Monitoring",
        Alarm_View: "Alarm Management",
        AlarmRules_View: "Alarm Rule Setting",
        AlarmPushRules_View:"Alarm Push Rule",
        Agency_View: "Distributor Management",
        DeviceAnalysis_View:"Equipment Analysis",
        PredictiveMaintenance_View:"Predictive Maintenance",        
        RoutineMaintenance_View:"Routine Maintenance",
        DeviceStatistics_View:"Equipment Statistics",
        AirCompressorStatistical_View:"Product Statistics",
        GatewayStatusStatistics_View:"Gateway Status Statistics",
        AirCompressorKPIIndex_View: "Product KPI",
        InstallKPIIndex_View: "Installation KPI",
        InstallDashboard_View: "Real Time Install Dashboard",
        AlarmProcess_View:"Alarm Process",
        MobileSIMManagement_View :"CMCC SIM Management",
        UnicomManagement_View:"CUCC SIM Management",
        Agency_View: "Distributor Management",
        DeviceImage_View:"Product Image",
        BusinessInfoPush_View:"Business Information",
        BusinessInfoPushList_View:"Business Information Pushed List",
        StatisticalForm:"Statistical Form",
        StationInfo:"Station Information",
        MaintenancePlan:"Routine Maintenance",
        UtilizationStatistical_View:"Product Utilization Rate Statistics",
        UtilizationStatNew_View:"Product Utilization Rate Statistics",
        LoadedRateStatistics_View:"Loaded Rate Statistics",
        EmcPotentialCustomer_View:"EMC Potential Customer",
        Ota_View:"Equipment Firmware Package Management",
        OtaUpgrade_View:"OTA Management",
        LoginLogger_View: "Login Log",
        Brand_View:"Brand Management",
        RunningTime_View:"Running Time Report",
        ThirdMonitor_View:"Equipment Monitor",
        Unbound_View:"Unbound Report",
        PMReport_View:"PM Report",
        MisureReport_View:"Misure Report",
        CustomerReport_View:"Customer Abstract Report",
        PartReport_View:"Part Report",
        AssetReport_View:"Asset Abstract Report",
        AlarmReport_View:"Alarm Summary Report",
        InstallReport_View:"Install Dashboard",
        PasswordLog_View:"Password Modification Log",
        MaintainRecord_View:"Maintain Service Record",
        GatherUnit_View:"PAC Unit Conversion Formula",
        Endurance_View:"Endurance Test Equipment Registration",
        EnduranceManagement_View:"Endurance Test",
        AIDiagnosis_View:"Motor Vibration AI Diagnostics",
        AlarmTranslation_View:"Alarm Translation",
        UserDeviceRel_View:"Man Equipment Comparison",
        EMC_Manage_View:"EMC Station Management",
        EMC_StationProject_View:"EMC Station Project Management",
    },
    acronym:{
        airCompressorSN:"DSN",
        gatewaySN:"GSN",
        gatewayBindingStatus:"Binding Status",
        ccn:"CCN",
        gatewaystatus:"Gateway Status",
        serviceType:"Service Type",
        serviceStatus:"Service Staus",
        installMethod:"Install Method",
        fieldInstallation:"RetroFit",
        plantErection:"Factory Fit",
        factory:"Factory Fit",
        scene:"RetroFit",
        null:"",
        undefined:"",
        "":"",
    },
    sim:{
        TotalSIMCards:'Total SIM Cards',
        CostOfLastMonth:'Cost Of Last Month',
        sheet:'sheet',
        yuan:'￥',
        month:'Month',
        DataThisMonth:'Data Stream This Month',
        SimDetails:'SIM Card Details',
        SIMActivationStatus:'SIM Activation Status',
        ExpensesInRecentSixMonths:'Cost in recent 6 months',
        TrafficUsageInRecentSevendays:'Data Stream in recent 7 Days',
        TrafficUsageInRecentSixMonths:'Data Stream in recent 6 Months',
        cost:'Cost',
        flow:'Stream',
        ClickToViewDetails:'Click To Details',
        Activated:"Activated",
        NotActive:"Not Active",
        Shutdown:'Shutdown',
        Testable:'Testable',
        Stock:'Stock',
        PreCancellation:'Pre Cancellation',
        other:"Other: ",
        simNo:'SIM No',
        simStatus:'SIM Status',
        bindSnNo:'Bind Sn No',
        gatewayNo:"Gateway No",
        monthlyFlow:"Monthly Flow",
        monthlyFee:'Monthly Fee',
        locationFail:'localization failed',
        locationsuccess:'localization successful',
    },
    unicom:{
        "testable":"Testable",
        "activatable":"Activatable",
        "activated":"Activated",
        "deactivated":"Deactivated",
        "invalid":"Invalid",
        "cleared":"Cleared",
        "replaced":"Replaced",
        "stock":"Stock",
        "start":"Start",
    },
    lable:{
        BusinessPush:'Web Notice',
        NoticPush:'App Notice',
        EmailPush:'Email Notice',
    },
    station:{
        projectName: "station project name",
        addProjectName: "add station project",
        projectNameEn: "station english name",
        industryName: "industry name",
        create:'Create station Infomation ',
        edit:'Edit station Infomation',
        region: "region",
        province: "province",
        city:'city',
        stationImgUrl:'station image',
        originUnitConsump: "original unit consumption",
        electPrice: "elect price"
    },
    ota:{        
        selectAll:"please select",
        online:"online",
        offline:"offline",
        warning:"warning",
        remark:"Remark",        
        controllCcn: "Software CCN",
        ccnVersion: "CCN Version",
        FirmwareUpgrade:'Upgrade Task',
        FirmwareUpgradeName:'Upgrade Task Name',
        FirmwareSelect:'Software',
        upgradeRemark:'Upgrade Remark',
        FirmwareUpload:'Equipment Software Upload',
        FirmwareName:'Equipment Software Name',
        DeviceModel:'DeviceModel',
        VersionNumber:'Firmware Version No.',
        engineerVersionNo:'Engineer Version No.',
        upgradeDesc:'Update Description',
        Upload:'Upload',
        UploadFile:'Upload File',
        tipsMessage1:'Only one file can be uploaded at most!',
        tipsMessage2:'Incorrect file format!',
        create:'Create Software Infomation ',
        edit:'Edit Software Infomation',
        createUpgrade:'Create Upgrade Task',
        editUpgrade:'Edit Upgrade Task',
        cofirmDelete:'Remove',
        geteWayName:'GeteWay Name',
        oldVersion:'Current Version',
        newVersion:'New Version',
        firnwarUpgrade:'Firmware Version Upgrade',
        selectVersion:'Please select firmware version',
        upgradeSuccess:"Upgrade instruction has been created and is being issued",
        upgradeDeviceSaveSuccess:"Upgrade Equipment setting ",
        upgradeFileSending:"Upgrade file has been issued",
        upgradeInstallSending:"Upgrade install command has been issued",           
        upgradePushFileTime:"Push file time",
        upgradeDownLoadFileTime:"Download file time",
        upgradeScheduledTime:"Scheduled time",
        upgradePushInstallTime:"Push install time",
        upgradePushFileTitle:"Push upgrade file",
        upgradePushInstallTitle:"Push upgrade install command",        
        confirmPushUpgradeInstall:"Is confirm push upgrade file？",
        confirmPushFile:"Is confirm Push upgrade install command？",
        deviceType:"Equipment Type",
        deviceBrand:"Equipment Manufacturer",
        gateway:"Gateway",
        controller:"Controller",
        upgradeCompleted:"Upgrade Complete",
        upgradeSucceeded:"Upgrade Succeeded",
        upgradeFailed:"Upgrade Failed",
        upgrading:"Upgrading",
        batchUpgrade:"Setting Upgrade Equipment",
        upgradeResult:"Upgrade Result",
        airCompressor:"Air Compressor",
        releaseTime:"Release Time",
        upgradeStatus:"Upgrade Status",
        flowStatus:"Flow Status",
        completionTime:"Completion Time",
        notUpgraded:"Not Upgraded",
        issued:"Issued",
        RegularUpgrade:"Regular Upgrade",
        TotalUpgrades:"Total upgrades:",
        NumberOfSuccesses:"Number of successes:",
        NumberOfFailures:"Number of failures:",
        "手动升级成功":"Manual upgrade succeeded",
        "已安装升级包":"已安装升级包",
        "已接收安装命令":"Upgrade Package Installed",
        "已下发安装命令":"Installation Command Issued",
        "已下载升级包":"Downloaded Upgrade Package",
        "已下发升级包":"Upgrade Package Issued",
        "未升级":"Not Upgraded",
        "下载失败":"Download Failed",
        "接收命令失败":"Failed to Receive Command",
        "安装失败":"Installation Failed",
        "手动升级失败":"Manual Upgrade Failed",
    },
    forgetpws:{
        Forgetthepassword:'Forgot password?',
        Fillinemailaddress:'Fill In Email Address',
        FillRightEmail:'Fill in the account number or reserved email address, then send the verification code',
        CodeReceived:'Fill in the verification code received in the email and reset the password',
        complete:'Complete',
        Verificationsuccessful:'Verification successful, complete password reset',
        inputEmail:'Please enter your account or email address',
        next:"Next, Send verification code",
        VerificationCode:'Verification Code',
        ResendCode:'Resend Verification Code ',
        ResendCodeTips:'The verification code has been sent to the account mailbox. Please check it. If not, please click resend the verification code.',
        newpsw:'Please enter a new password',
        newpsw1:'Enter the new password again',
        newpsw3:'Please enter the new password again',
        confirmbtn:'Confirm',
        setclick:'Set successfully! Click',
        loginAgin:' , login again!',
        IllegalEmail:'Illegal email address',
        frequently:'The verification code is sent frequently',
        InvalidCode:'Invalid verification code',
        expiredCode:'The verification code has expired',
        existEmail:'Email address does not exist',
        accountOrEmail:"Account/Email",
       
    },
    dataAuth:{
        DataPermissions:"Data Permissions",
        PermissionSetting:"Data Permission Setting",
        NoRestrictions:"No Restrictions",
        SwitchingTime:"Switching Time",
        LastMonth:"Last Month",
        LastThreeMonths:"Last Three Months",
        LastSixMonths:"Last Six Months",
        LastYear:"Last Year",
    },
    RunningTIme:{
        FileName:"File Name",
        Name:"Name",
        Type:"Type",
        LastModify:"Last Modified",
        Size:"Size",
        StorageClass:"Storage Class",
        Download:"Download",
        DownloadReport:"Download Inspection Report",
        reportType:"Report Type",
        custReport:"Customer Report",
        viewReport:"View Report",
        reportDate:"Report Date"
    },
    opeateType:{
        create:"Create",
        edit:"Edit",
        reset:"Admin Reset",
        forget:"User Reset"
    },
    logType:{
        "修改":"Update",
        "创建":"Add",
        "网关绑定":"Bind",
        "删除":"Delete",
        "网关解绑":"Unbind",
        "错误":"Error",
        "其它":"Other"
    },
    userType:{
        backStage:"Back Stage",
        cutomer:"Customer",
        agency:"Agency"
    },
    pwdTips:{
        "密码长度必须大于等于8位！":"The password length must be greater than or equal to 8 bits!",
        "密码至少包含大写字母、小写字母、数字、符号中任意三个！":"The password must contain at least three uppercase letters, lowercase letters, numbers and symbols!",
        "新密码不能包含账号名称或者全名！":"The new password cannot contain account name or full name!",
        "新密码不能是当前密码！":"The new password cannot be the current password!",
        "新密码不能是最近已使用的24个密码！":"The new password cannot be the 24 passwords that have been used recently!",
        "原密码不正确":"The original password is incorrect!",
        "change501":"The new account or the account that has reset the password, need to modify the password before you can access the system.",
        "change502":"It has been more than 90 days since you last changed your password. Please change your password first."
    },
    loginTips:{
        "请输入正确的账号或密码！":"Please enter the correct account or password!",
        "该账号已被冻结！":"The account has been frozen!",
        "该账号未绑定邮箱，无法登陆":"This account is not bound to email, unable to log in",
        "该账号已被锁定":"The account has been locked",
        "登录失败！":"Login failed!",
        "sso类型账号请使用sso登录！":"Please log in to the system using the sso method!"
    },
    maintain:{
        "timeRange":"Service Time Range",
        "openTime":"Boot Time",
        "maintainType":"Service Type",
        "orderCode":"Service Order Code",
        "serviceContent":"Service Content",
        "runningHour":"Running Hour",
        "serviceTime":"Service Time"
    },
    insight:{
        "已运行时长":"",
        "上次更换日":"",
        "上次更换运行时长":"",
        "推荐更换周期":"",
        "首次预报警时间":"",
        "末次预报警时间":"",
        "建议":"",
        "前两周低气压状态占比":"",
        "后两周低气压状态占比":"",
        "日（告警时间）":"",
        "告警信息":"",
        "原因":"",
        "解决方案":"",
        "频繁开关机":"",
        "机组排期压力":"",
        "长时间卸载":"",
        "频繁加卸载":"",
        "油分":"",
        "油滤":"",
        "空滤":"",
        "冷却风进气温度":"",
        "总分":"",
        "利用率":"",
        "管路":"",
        "电机":"",
        "进气阀":"",
        "温控阀":"",
        "最小压力阀（有油）":"",
        "放空阀（无油）":"",
        "中冷（无油）":"",
        "后冷":"",
        "油冷":"",
        "油分离桶（有油）":"",
        "定频":"",
        "变频1":"",
        "变频2":"",
        "来源-2":"",
        "insightTitle21":"",
        "insightTitle27":"",
        "insightTitle29":""
    },
    gatherUnit:{
        "inputUnit":"Input Unit",
        "outputUnit":"Output Unit",
        "offset":"Offset",
        "scale":"Scale",
        "addFormula":"Add Formula",
        "editFormula":"Edit Formula",
    },
    formula:{
        "注册总数":"The total number of equipments that have been installed and bound in the IoT platform",
        "在线数":"The number of equipments that have been running for at least 10 hours within 30 days",
        "未连接数":"The number of equipments that run for less than 10 hours within 30 days",
        "警告台数":"Indicates the number of equipments for which alarms have been generated in this month or alarms have not been cleared. ",
        "故障台数":"Indicates the number of equipments that have been faulty in this month or have unrectified faults",
        "空压机健康度":"(Number of online equipments - Number of online equipments in faulty  ) ÷ Number of online device",
        "客户月利用率":"Average daily utilization rate of all equipments in last month(Daily utilization rate=running hours in a single day÷24 Hours)",
        "单台设备日利用率":"",
        "单台设备月利用率":"",
        "单台设备月加载率":"",
        "最近12个月单台设备月利用率":"Average daily utilization of monthly operating days over the last 12 months (Daily utilization rate= running hours in a single day÷24 Hours)",
        "最近12个月单台设备月加载率":"Monthly load rate = monthly load time ÷ monthly running time",
    },
    web:{
        viewMonitor:"View Monitor",
        warnMonitor:"Warning Monitor",
        monitorChart:"Monitor List",
        MonitoringDate:"Monitoring Date",
        MonitoringParameters:"Monitoring Parameters",
        realtimemonitoring:"Real Time Monitoring",
        historymonitoring:"History Monitoring",
        monitortableDetail:"Monitor Table Detail",
        selectMonitoringParameters:"Please Select Monitoring Parameters",
        monitorIndex: "Monitor Index",
        monitorDataDetail:"Monitoring Details",
        DeviceMonitorManagement_View: "Equipment Remote Monitoring",
    },
    multiBrand:{
        ACIoTMP:"Product IoT Management Platform",
        ACDMap:"Product Distribution Map",
        totalShipment:"Total Shipment",
        registration:"Registration",
        online:"Online",
        warning:"Warning",
        trip:"Trip",
        utilization:"Utilization",
        offline:"Offline"
    },
    alarmPushRule:{
        ruleCode:"Rule Code",
        ruleName:"Rule Name",
        isPush:"Push or Not",
        isRepeat:"Repeat Push or Not",
        cycleValue:"Push Cycle",
        cycleUnit:"Cycle Unit",
        cycleCondition:"Push Condition",
        isAttachAlarmMsg:"Whether Alarm Snapshot is Attached",
        hour:"hour",
        day:"day",
        week:"week",
        month:"month",
        addRule:"Add Rule",
        editRule:"Edit Rule",
        range:"Range",
        all:"All",
        customize:"Customize",
        ruleDetail:"Detail",
        bindCcnErrorInfo: "Choose Error Message",
    },
    city:{
        中国: "China",
        华北: "North China",
        华东: "East China",
        华南: "	South China",
        东北: "Northeast China",
        华中: "Central China",
        北京: "Beijing",
        上海: "Shanghai",
        天津: "Tianjin",
        重庆: "Chongqing",
        西藏: "Tibet",
        拉萨: "Lhasa",
        阿里地区: "Ali region",
        山南: "Shannan",
        昌都: "Qamdo",
        日喀则: "Shigatse",
        那曲: "Naqu",
        林芝: "Nyingchi",
        新疆: "Xinjiang",
        乌鲁木齐: "Urumqi",
        克拉玛依: "Karamay",
        吐鲁番: "Turpan",
        哈密: "Hami",
        昌吉回族自治州: "Changji Hui Autonomous Prefecture",
        博尔塔拉蒙古自治州: "Bortala Mongolian Autonomous Prefecture",
        巴音郭楞蒙古自治州: "Bayingolin Mongolian Autonomous Prefecture",
        阿克苏地区: "Aksu region",
        克孜勒苏柯尔克孜自治州: "Kizilsu Kirgiz Autonomous Prefecture",
        喀什地区: "Kashgar area",
        和田地区: "Hotan area",
        伊犁哈萨克自治州: "Ili Kazak Autonomous Prefecture",
        塔城地区: "Tacheng area",
        阿勒泰地区: "Altay region",
        石河子: "Shihezi",
        阿拉尔: "Aral",
        图木舒克: "Tumushuk",
        五家渠: "Wujiaqu",
        北屯: "Beitun",
        铁门关: "Tiemenguan",
        双河: "Shuanghe",
        可克达拉: "Cokedala",
        昆玉: "Kunyu",
        胡杨河: "Huyanghe",
        甘肃: "Gansu",
        兰州: "Lanzhou",
        临夏回族自治州: "Linxia Hui Autonomous Prefecture",
        金昌: "Jinchang",
        张掖: "Zhangye",
        酒泉: "Jiuquan",
        定西: "Dingxi",
        甘南藏族自治州: "Gannan Tibetan Autonomous Prefecture",
        白银: "Baiyin",
        陇南: "Longnan",
        天水: "Tianshui",
        庆阳: "Qingyang",
        嘉峪关: "Jiayuguan Pass",
        武威: "Wuwei",
        平凉: "Hirang",
        陕西: "Shaanxi",
        西安: "Xi'an",
        汉中: "Hanzhong",
        咸阳: "Xianyang",
        榆林: "Yulin",
        安康: "Health and well'being",
        延安: "Yan'an",
        宝鸡: "Baoji",
        商洛: "Shangluo",
        渭南: "Weinan",
        铜川: "Tongchuan",
        四川: "Sichuan",
        成都: "Chengdu",
        自贡: "Zigong",
        攀枝花: "Panzhihua",
        泸州: "Luzhou",
        德阳: "Deyang",
        绵阳: "Mianyang",
        广元: "Guangyuan",
        遂宁: "Suining",
        内江: "Neijiang River",
        乐山: "Leshan",
        南充: "Nanchong",
        眉山: "Meishan",
        宜宾: "Yibin",
        广安: "Guang'an",
        达州: "Dazhou",
        雅安: "Ya'an",
        巴中: "Bazhong",
        资阳: "Ziyang",
        阿坝藏族羌族自治州: "Aba Tibetan and Qiang Autonomous Prefecture",
        甘孜藏族自治州: "Ganzi Tibetan Autonomous Prefecture",
        凉山彝族自治州: "Liangshan Yi Autonomous Prefecture",
        广西: "Guangxi",
        南宁: "Nanning",
        柳州: "Liuzhou",
        桂林: "Guilin",
        梧州: "Wuzhou",
        北海: "Beihai",
        防城港: "Fangcheng port",
        钦州: "Qinzhou",
        贵港: "Guigang",
        玉林: "Yulin",
        百色: "Baise",
        贺州: "Hezhou",
        河池: "Hechi",
        来宾: "Laizbinh",
        崇左: "Chongzuo",
        河南: "Henan",
        郑州: "Zhengzhou",
        开封: "Kaifeng",
        洛阳: "Luoyang",
        平顶山: "Pingdingshan",
        安阳: "Anyang",
        鹤壁: "Hebi",
        新乡: "Xinxiang",
        焦作: "Jiaozuo",
        濮阳: "Puyang",
        许昌: "Xuchang",
        漯河: "Luohe",
        三门峡: "Sanmenxia",
        南阳: "Nanyang",
        商丘: "Shangqiu",
        信阳: "Xinyang",
        周口: "Zhoukou",
        驻马店: "Zhumadian",
        济源: "Jiyuan",
        内蒙古: "Inner Mongolia",
        赤峰: "Chifeng",
        呼伦贝尔: "Hulunbuir",
        兴安盟: "Hinggan League",
        呼和浩特: "Hohhot",
        包头: "baotou",
        乌海: "Wuhai",
        通辽: "Tongliao",
        鄂尔多斯: "Ordos",
        巴彦淖尔: "Bayannur",
        乌兰察布: "Ulanqab",
        锡林郭勒盟: "Xilin Gol League",
        阿拉善盟: "Alxa League",
        吉林: "Jilin",
        长春: "Changchun",
        四平: "Siping",
        辽源: "Liaoyuan",
        通化: "Tonghua",
        白山: "Baishan",
        松原: "Songyuan",
        白城: "Baicheng",
        延边朝鲜族自治州: "Yanbian Korean Autonomous Prefecture",
        浙江: "Zhejiang",
        杭州: "Hangzhou",
        宁波: "Ningbo",
        温州: "Wenzhou",
        嘉兴: "Jiaxing",
        湖州: "Huzhou",
        绍兴: "Shaoxing",
        金华: "Jinhua",
        衢州: "Quzhou",
        舟山: "Zhoushan",
        台州: "Taizhou",
        丽水: "Lishui",
        江西: "Jiangxi",
        南昌: "Nanchang",
        景德镇: "Jingdezhen",
        萍乡: "Pingxiang",
        九江: "Jiujiang",
        新余: "Xinyu",
        鹰潭: "Yingtan",
        赣州: "Ganzhou",
        吉安: "Gian",
        宜春: "Yichun",
        抚州: "Fuzhou",
        上饶: "Shangrao",
        湖北: "Hubei",
        武汉: "Wuhan",
        黄石: "Huangshi",
        十堰: "Shiyan",
        宜昌: "Yichang",
        襄阳: "Xiangyang",
        鄂州: "Ezhou",
        荆门: "Jingmen",
        孝感: "Xiaogan",
        荆州: "Jingzhou",
        黄冈: "Huanggang",
        咸宁: "Xianning",
        随州: "Suizhou",
        仙桃: "Xiantao",
        潜江: "Qianjiang",
        天门: "Tianmen",
        恩施土家族苗族自治州: "Enshi Tujia and Miao Autonomous Prefecture",
        神农架林区: "Shennongjia Forest area",
        广东: "Guangdong",
        广州: "Guangzhou",
        韶关: "Shaoguan",
        深圳: "Shenzhen",
        珠海: "Zhuhai",
        汕头: "Shantou",
        佛山: "Foshan",
        江门: "Jiangmen",
        湛江: "Zhanjiang",
        茂名: "Maoming",
        肇庆: "Zhaoqing",
        惠州: "Huizhou",
        梅州: "Meizhou",
        汕尾: "Shanwei",
        河源: "Heyuan",
        阳江: "Yangjiang",
        清远: "Qingyuan",
        东莞: "Dongguan",
        中山: "Zhongshan",
        潮州: "Chaozhou",
        揭阳: "Jieyang",
        云浮: "Yunfu",
        贵州: "Guizhou",
        贵阳: "Guiyang",
        遵义: "Zunyi",
        六盘水: "Liupanshui",
        安顺: "Anshun",
        毕节: "Bijie",
        铜仁: "Tongren",
        黔西南布依族苗族自治州: "Qiandinan Buyi and Miao Autonomous Prefecture",
        黔东南苗族侗族自治州: "Qiandongnan Miao and Dong Autonomous Prefecture",
        黔南布依族苗族自治州: "Qiannan Buyi and Miao Autonomous Prefecture",
        青海: "Qinghai",
        西宁: "Xining",
        海东: "Haidong",
        海北藏族自治州: "Haibei Tibetan Autonomous Prefecture",
        黄南藏族自治州: "Huangnan Tibetan Autonomous Prefecture",
        海南藏族自治州: "Hainan Tibetan Autonomous Prefecture",
        果洛藏族自治州: "Guoluo Tibetan Autonomous Prefecture",
        玉树藏族自治州: "Tibetan Autonomous Prefecture of Yushu",
        海西蒙古族藏族自治州: "Haixi Mongolian and Tibetan Autonomous Prefecture",
        辽宁: "Liaoning",
        沈阳: "Shenyang",
        大连: "Dalian",
        鞍山: "Anshan",
        抚顺: "Fushun",
        本溪: "Benxi",
        丹东: "Danton",
        锦州: "Jinzhou",
        营口: "Yingkou",
        阜新: "Fuxin",
        辽阳: "Liaoyang",
        盘锦: "panjin",
        铁岭: "Tieling",
        朝阳: "Chaoyang",
        葫芦岛: "Huludao",
        江苏: "Jiangsu",
        南京: "Nanjing",
        无锡: "Wuxi",
        徐州: "Xuzhou",
        常州: "Changzhou",
        南通: "Nantong",
        苏州: "Suzhou",
        连云港: "Lianyungang",
        淮安: "Huai'an",
        盐城: "Yancheng",
        扬州: "Yangzhou",
        镇江: "Zhenjiang",
        泰州: "Taizhou",
        宿迁: "Suqian",
        安徽: "Anhui",
        合肥: "Hefei",
        芜湖: "Wuhu",
        蚌埠: "Bengbu",
        淮南: "Huainan",
        马鞍山: "Ma'anshan",
        淮北: "Huaibei",
        铜陵: "Tongling",
        安庆: "Anqing",
        黄山: "Huangshan",
        滁州: "Chuzhou",
        阜阳: "Fuyang",
        宿州: "Suzhou",
        六安: "Lu'an",
        亳州: "Bozhou",
        池州: "Chizhou",
        宣城: "Xuancheng",
        河北: "Hebei",
        石家庄: "Shijiazhuang",
        唐山: "Tangshan",
        秦皇岛: "Qinhuangdao",
        邯郸: "Handan",
        邢台: "Xingtai",
        保定: "Baoding",
        张家口: "Zhangjiakou",
        承德: "Chengde",
        沧州: "Cangzhou",
        廊坊: "Langfang",
        衡水: "Hengshui",
        山西: "Shanxi",
        太原: "Taiyuan",
        大同: "Datong",
        阳泉: "Yangquan",
        长治: "changzhi",
        晋城: "Jincheng",
        朔州: "Shuozhou",
        晋中: "Jinzhong",
        运城: "Yuncheng",
        忻州: "Xinzhou",
        临汾: "Linfen",
        吕梁: "Luliang",
        黑龙江: "Heilongjiang",
        哈尔滨: "Harbin",
        齐齐哈尔: "Qiqihar",
        鹤岗: "Hegang",
        鸡西: "Jixi",
        双鸭山: "Shuangyashan",
        大庆: "Daqing",
        伊春: "Yichun",
        佳木斯: "Jiamusi",
        七台河: "Qitaihe",
        牡丹江: "Mudanjiang",
        黑河: "Heihe",
        绥化: "Suihua",
        大兴安岭地区: "Daxing'anling",
        福建: "Fujian",
        福州: "Fuzhou",
        厦门: "Xiamen",
        莆田: "Putian",
        三明: "Sanming",
        泉州: "Quanzhou",
        漳州: "Zhangzhou",
        南平: "Nanping",
        龙岩: "Longyan",
        宁德: "Ningde",
        山东: "Shandong",
        济南: "Jinan",
        青岛: "Qingdao",
        淄博: "Zibo",
        枣庄: "Zaozhuang",
        东营: "Dongying",
        烟台: "Yantai",
        潍坊: "Weifang",
        济宁: "Jining",
        泰安: "Tai'an",
        威海: "Weihai",
        日照: "Rizhao",
        临沂: "Linyi",
        德州: "Dezhou",
        聊城: "Liaocheng",
        滨州: "Binzhou",
        菏泽: "Heze",
        湖南: "Hunan",
        长沙: "Changsha",
        株洲: "Zhuzhou",
        湘潭: "Xiangtan",
        衡阳: "Hengyang",
        邵阳: "Shaoyang",
        岳阳: "Yueyang",
        常德: "Changde",
        张家界: "Zhangjiajie",
        益阳: "Yiyang",
        郴州: "Chenzhou",
        永州: "Yongzhou",
        怀化: "Huaihua",
        娄底: "Loudi",
        湘西土家族苗族自治州: "Xiangxi Tujia and Miao Autonomous Prefecture",
        海南: "Hainan",
        海口: "Haikou",
        三亚: "Sanya",
        三沙: "Sansha",
        儋州: "Danzhou",
        五指山: "Wuzhishan",
        琼海: "Qionghai",
        文昌: "Wenchang",
        万宁: "Wanning",
        东方: "Dongfang",
        定安县: "Ding'an",
        屯昌县: "Tunchang",
        澄迈县: "Chengmai",
        临高县: "Lingao",
        白沙黎族自治县: "Baisha",
        昌江黎族自治县: "Changjiang",
        乐东黎族自治县: "Ledong",
        陵水黎族自治县: "Lingshui",
        保亭黎族苗族自治县: "Baoting",
        琼中黎族苗族自治县: "Qiongzhong",
        云南: "Yunnan",
        昆明: "Kunming",
        曲靖: "Qujing",
        玉溪: "Yuxi",
        保山: "Baoshan",
        昭通: "Zhaotong",
        丽江: "Lijiang",
        普洱: "Pu'er",
        临沧: "Lincang",
        楚雄彝族自治州: "Chuxiong",
        红河哈尼族彝族自治州: "Honghe",
        文山壮族苗族自治州: "Wenshan",
        西双版纳傣族自治州: "Xishuangbanna",
        大理白族自治州: "Dali",
        德宏傣族景颇族自治州: "Dehong",
        怒江傈僳族自治州: "Nujiang",
        迪庆藏族自治州: "Diqing",
        宁夏: "Ningxia",
        银川: "Yinchuan",
        石嘴山: "Shizuishan",
        吴忠: "Wuzhong",
        固原: "Guyuan",
        中卫: "Zhongwei",
        香港: "Hong Kong",
        澳门: "Macao",
        中国台湾: "Taiwan",
        台北: "Taipei",
        高雄: "Kaohsiung",
        基隆: "Keelung",
        台中: "Taichung",
        台南: "Tainan",
        新竹: "Hsinchu",
        嘉义: "Chiayi",
        新北: "New Taipei",
        桃园: "Taoyuan",
    },
    importError: {
        dsnIsEmpty: "Dsn is empty",
        ccnIsEmpty: "Ccn is empty",
        errorCodeIsEmpty: "Error Code is empty",
        errorDescriptionIsEmpty: "Error Description is empty",
        errorTypeIsEmpty: "Error Type is empty",
        expertAdviceIsEmpty: "Expert Advice is empty",
        monitorIndexIsEmpty: "Monitor Index is empty",
        companyCodeIsEmpty: "Customer Code is empty",
        companyNameIsEmpty: ", Customer Name is empty",
        customerCodeIsEmpty: "Customer Code is empty",
        customerNameIsEmpty: ", Customer Name is empty",
        customerCharaterIsEmpty: ", Customer Character is empty",
        gsnIsEmpty: "Gsn is empty",
        runningTimeError: " Error in Running Hour column",
        runningTimeinteger: "Running Hour must be an integer",
        devicesnIsEmpty: "Dsn is empty",
        emailIsEmpty: "Email is empty",
        noSuchEmail: "The email does not exist in the system!",
        "exceptionLine":"Exception - Line ",
        "exceptionSheet":"Exception - ",
        "数据第": " - Line ",
        "行异常:":":",
        "已存在": "The same ",
        "客户代码":" Customer Code ",
        "单位性质":" Customer Character ",
        "管理单位代码":" Management Owner Code ",
        "相同的数据": " already exists",
        "theSameDsnAlreadyExists": " The same Dsn already exists ",
        "theSameCcnAlreadyExists": " The same Ccn and CcnVersion already exists ",
        "theSameCustomerCodeAlreadyExists": " The same Customer Code already exists ",
        "theSameGsnAlreadyExists": " The same Gsn already exists ",
        "readFailCcn":"Excel table reading failed, unable to find sheets named 'Ccn' and 'Error Message'",
        "readFailExpertAdvice":"Excel table reading failed, unable to find sheets named 'Expert Advice'",
        "only":"Only ",
        "selectAgain":" file can be selected. Please delete the file first and then select again",
        "onlySelect": "Only the xlsx and xls files can be selected",
    },
    exportContent: {
        "监控历史数据": "Monitor historical data",
        "空压机服务明细":"Product service detail",
        "告警信息列表": "Alarm list",
        "点表导出": "Ccn Export",
        "点表总目录导出": "Parameter General Catalogue Export",
        "defaultOrNot":"Default or not",
        "BV客户区域列表":"BV Customer Region List",
        "Rotary客户区域列表":"Rotary Customer Region List",
        "经销商列表导出": "Distributor Managed list export",
        "客户列表导出": "Customer list export",
        "PAC客户区域列表": "PAC Customer Region List",
        "空压机机型列表": "Product Models List",
        "耐久性测试设备登记列表": "Endurance Test Equipment Registration List",
        "空压机网关列表": "Gateway List",
        "OTA升级任务": "OTA upgrade task",
        "升级结果导出": "Upgrade result export",
        "预测维护空压机列表导出": "Routine Maintenance List",
        "解绑空压机列表": "Unbound Products List",
        "解绑详细列表":"Unbound Products Detail",
        "整体趋势图": "Overall Trend Chart",
        "工厂安装趋势图": "Factory Fit Trend Chart",
        "现场安装趋势图": "RetroFit Trend Chart",
        "各行业利用率":"Utilization Rate of Each Industry",
        "各客户中心利用率":"Utilization Rate of Each Customer Center",
        "用户列表": "User List",
        "维护记录表": "Maintenance Record List",
    },
    coodMode: {
        "风冷": "Air cooling",
        "水冷": "Water cooling",
        "":"",
        "undefined":"",
        "unll": "",
    },
    errorMsg:{
      addFailAlarmTranslation:"Add failed: the same data already exists",
    },
    eightSpan:{
        BS5DH0:"Package Discharge Pressure",
        BM2000:"Package Status",
        SVT0:"Inlet Pressure",
        IDP0:"Package Status",
        BG0:"Package Status",
        BS5DH1:"Running Time",
        BM2001:"Blower Inlet Pressure",
        SVT1:"Airend Discharge Pressure",
        IDP1:"Running Time",
        BG1:"Running Time",
        BS5DH2:"Loaded Time",
        BM2002:"Blower Inlet Temperature",
        SVT2:"Oil Injection Pressure",
        IDP2:"Loaded Time",
        BG2:"Loaded Time",
        BS5DH3:"Airend Discharge Pressure",
        BM2003:"Package Discharge Pressure",
        SVT3:"Target Pressure",
        IDP3:"Vacuum Pump Inlet Pressure",
        BG3:"Package Discharge Pressure",
        BS5DH4:"Rated Pressure",
        BM2004:"Main Motor Winding Temperature",
        SVT4:"Running Time",
        IDP4:"Target Pressure",
        BG4:"High-speed Shaft Vibration",
        BS5DH5:"Airend Discharge Temperature",
        BM2005:"Current Flow",
        SVT5:"Main Vsd Motor Current",
        IDP5:"Vacuum Pump Case Temperature",
        BG5:"Package Discharge Temperature",
        BS5DH6:"Compression Ratio",
        BM2006:"Main Vsd Motor speed",
        SVT6:"Main Vsd Motor Voltage",
        IDP6:"Main Vsd Motor Speed",
        BG6:"Main Motor Current",
        MC0:"Package Status",
        MC1:"P_Package Discharge",
        MC2:"Target Pressure",
        MC3:"T_S4 Discharge",
        MC4:"T_Ambient",
        MC5:"MM1_Speed",
        MC6:"MM2_Speed"
    }
}
